import {MeasurementStatus} from "../../found-measurement";
import {AssignType} from "../../list-item";

export interface AllowDoctorAnalysisParams {
  status: MeasurementStatus;
  isGlobalTechnician: boolean;
  analysisAssignType?: AssignType;
  preAnalysisAssignType?: AssignType;
}

export function canDoctorAnalyseMeasurementInStatus(
  {
    status,
    analysisAssignType,
    isGlobalTechnician,
    preAnalysisAssignType
  }: AllowDoctorAnalysisParams) {

  if (status === "PRE_ANALYSIS" && analysisAssignType === undefined && preAnalysisAssignType !== undefined) {
    return !isGlobalTechnician || preAnalysisAssignType === "GLOBAL_TECHNICIAN_POOL";
  }

  if (status === "READY_FOR_ANALYSIS" && analysisAssignType !== undefined) {
    return !isGlobalTechnician || analysisAssignType === "GLOBAL_TECHNICIAN_POOL" && preAnalysisAssignType === undefined;
  }

  return false;
}
